import React, { useEffect, useState } from "react";
import PackageCard from "./PackageCard";
import { getPublicSubscription } from "../../../services/publicService";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const PackageSelection = ({ onSuccess }) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [packageData, setPackageData] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);

  useEffect(() => {
    fetchPackages();
  }, [id]);

  const fetchPackages = async () => {
    try {
      setLoading(true);
      const res = await getPublicSubscription(id);
      setPackageData(res);
    } catch (err) {
      toast.error("Failed to load packages");
    } finally {
      setLoading(false);
    }
  };

  const handleContinue = () => {
    if (!selectedPackage) {
      toast.error("Please select a package.");
      return;
    }

    onSuccess(selectedPackage);
  };

  return (
    <div className="package-wrapper">
      <div className="package-header">
        <h2>Select a Package</h2>
        <p>Choose the package that best suits you</p>
      </div>
      <div className="package-list">
        <div className="package-grid">
          {packageData?.map((pkg) => {
            const name = pkg.packageType?.name?.replace(" Package", "") || "";

            const selected = selectedPackage?.id === pkg.id;

            return (
              <div
                key={pkg.id}
                className={`package-card ${selected ? "selected" : ""}`}
                onClick={() => setSelectedPackage(pkg)}
              >
                <div className="package-content">
                  <div className="package-info">
                    <h3>{pkg.packageType?.name}</h3>

                    <p>{pkg.packageType?.description}</p>

                    {/* <ul>
                      <li>
                        <i className="fa fa-check"></i>Tournament Participation
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Match Day Kit
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Certificate of
                        Participation
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Refreshments
                      </li>

                      {name !== "Basic" && (
                        <li>
                          <i className="fa fa-check"></i>Player Stats & Ranking
                        </li>
                      )}

                      {name === "Premium" && (
                        <>
                          <li>
                            <i className="fa fa-check"></i>Awards for Top
                            Performers
                          </li>
                          <li>
                            <i className="fa fa-check"></i>Media Coverage
                          </li>
                        </>
                      )}
                    </ul> */}
                  </div>

                  <div className="package-price">
                    <h2>₹{pkg.ammount}</h2>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="package-footer">
        <button onClick={handleContinue}>Continue</button>
      </div>
    </div>
  );
};

export default PackageSelection;
